import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { Alert, Divider, Grid } from '@mui/material';
import { Select, Checkbox, Form } from 'Components';

import { catalogLoad } from 'Redux/actions';


const Step3 = (props) => {

    const { currentAlert, formRef, value, onChange, nextStep } = props
    const { messages } = useIntl()
    const dispatch = useDispatch()

    const contacts = useSelector((state) => state.catalogsRedux.contacts)
    const loadingContacts = useSelector((state) => state.catalogsRedux.loadingContacts)


    useEffect(() => {
        dispatch(catalogLoad(['contacts']));
        if(value?.config?.routeWatchers){
            onChange({   ...value, subscribers: [{ type: 'routeWatchers' }] })
        }

    }, [])

    return (
        <Form ref={formRef}
            noSubmit
            onValidSubmit={() => {
                nextStep()
            }}
        // onSubmit={() => {
        //     return internalFormRef.current?.submit();
        // }}
        >
            {
                value?.config?.routeWatchers 
                ?
                <div style={{ padding: 50 }}>
                    <label>{messages['alertsNewAlert_RouteWatchers_alertMessage']}</label>
                </div>
                :
                <Grid container justifyContent={'center'} direction={'column'}>
                    <Grid item>
                        <Select
                            id="selectSubscribers"
                            label={messages['alertsNewAlert_whoShouldReceiveTheseAlertsLabel']}
                            value={contacts.filter((contact) => value.subscribers?.find(x => x.contactId == contact.id)) || []}
                            onChange={(items = []) => {
                                onChange(
                                    {
                                        ...value,
                                        subscribers: items?.map((item) => { return { alert: true, alertAfter: false, contactId: item.id } })
                                    }
                                )
                            }}
                            options={contacts}
                            textField="title"
                            valueField="id"
                            placeholder={messages['alertsNewAlert_selectPlaceholder']}
                            isClearable
                            selectedOptionsBelow
                            multiple
                            loading={loadingContacts}
                            disabled={value.subscribers?.find(x => x.contactId == -1)}
                            requiredMessage={messages['required_field']}
                            required={!value.subscribers?.find(x => x.contactId == -1) && !value.subscribers?.find(x => x.contactId == -2)}
                        />
                    </Grid>
                    <Grid item>
                        <Checkbox
                            value={value.subscribers?.find(x => x.contactId == -1) ? true : false}
                            onChange={(event) => onChange({
                                ...value,
                                subscribers: event ? [{ alert: true, alertAfter: false, contactId: -1 }] : value.subscribers?.filter(x => x.contactId != -1)
                            })}
                            size="md"
                            className="checkReschedule"
                            id="allcontact"
                            label={messages['alertsNewAlert_selectAllContactsLabel']}
                            requiredMessage={messages['required_field']}
                            required={(!value.subscribers || value.subscribers?.length == 0) && !value.subscribers?.find(x => x.contactId == -2)}
                        />
                    </Grid>
                    <Grid item style={{ marginBottom: 20 }}>
                        <Checkbox
                            value={value.subscribers?.find(x => x.contactId == -2) ? true : false}
                            onChange={(event) => onChange({
                                ...value,
                                subscribers: event ? [...(value.subscribers || []), { alert: true, alertAfter: false, contactId: -2 }] : value.subscribers?.filter(x => x.contactId != -2)
                            })}
                            size="md"
                            className="checkReschedule"
                            id="currentDriver"
                            label={messages['alertsNewAlert_currentDriver']}
                            requiredMessage={messages['required_field']}
                            required={!value.subscribers?.find(x => x.contactId == -1) && (!value.subscribers || value.subscribers?.length == 0)}
                        />
                    </Grid>

                        {currentAlert.code == "Inspections" && (
                            <Grid item style={{ marginBottom: 30 }}>
                                <Alert severity='info' className='custom-info-alert'>{messages['alertsNewAlert_DriversMustBeAssignedInPXToReceiveAlertsDirectly']}</Alert>
                                <Divider style={{ marginTop: 30 }} />
                            </Grid>
                        )}
                </Grid>
            }
        </Form>
    );
}
export default Step3;
